import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/monero': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M352 384h108.4c-43.4 71.9-122.3 120-212.4 120s-169-48.1-212.4-120h108.4v-127.8l104 104.8 104-105v128zM88 336h-74.8c-8.6-25.1-13.2-52-13.2-80 0-137 111-248 248-248s248 111 248 248c0 28-4.7 54.9-13.2 80h-74.8v-208l-160.6 159.4-159.4-159.4v208z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/monero.js
// module id = 938
// module chunks = 0